import { Pipe, PipeTransform } from '@angular/core';

type unit = 'bytes' | 'KB' | 'MB' | 'GB';
const defaultPrecisionMap = {
  bytes: 0,
  KB: 0,
  MB: 1,
  GB: 1,
};

@Pipe({
  name: 'fileSize',
  standalone: false,
})
export class FileSizePipe implements PipeTransform {
  private readonly units: unit[] = ['bytes', 'KB', 'MB', 'GB'];

  transform(bytes = 0): string {
    if (Number.isNaN(parseFloat(String(bytes))) || !Number.isFinite(bytes)) {
      return '?';
    }

    let unitIndex = 0;
    while (bytes >= 1024) {
      bytes /= 1024;
      unitIndex += 1;
    }

    return `${bytes.toFixed(defaultPrecisionMap[this.units[unitIndex]])} ${this.units[unitIndex]}`;
  }
}
